var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgToolStackScroll = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 28,
  height: 28,
  viewBox: "0 0 28 28",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h28v28H0z"
}), /*#__PURE__*/React.createElement("rect", {
  stroke: "currentColor",
  strokeWidth: 1.5,
  x: 4,
  y: 9.714,
  width: 14.286,
  height: 14.286,
  rx: 2
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.01 6.857h11.98a2 2 0 0 1 2 2v12.286h0",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.714 4h11.982a2 2 0 0 1 2 2v12.286h0",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round"
}))));
export { SvgToolStackScroll as ReactComponent };
export default __webpack_public_path__ + "assets/images/tool-stack-scroll.svg";